{
  "workflow_step_and_status": {
    "CREATING": "En cours de création",
    "FIRST_VALIDATION": "Première validation",
    "SECOND_VALIDATION": "Deuxième validation",
    "TO_EDIT": "À modifier",
    "VALIDATING": "En cours de validation",
    "CONTRACT_MANAGEMENT": "En cours de soumission & gestion",
    "EVENT_IN_PROGRESS": "Évènement en cours",
    "EVENT_VALIDATING": "Validation dépenses",
    "EVENT_IS_FINISHED": "Évènement terminé",
    "CANCELED": "Annulé"
  },
  "deposit_status": {
    "CREATING": "À envoyer",
    "DONE": "Bot en succès",
    "FAILED": "Bot en échec",
    "PENDING": "Bot en cours",
    "CONVENTION_AUTHORIZED": "Convention autorisée",
    "CONVENTION_REFUSED": "Convention non autorisée",
    "SUBMISSION_INCOMPLETE": "Dossier incomplet",
    "VALIDATION_PENDING": "En attente de l’autorisation",
    "CANCELED": "Annulé",
    "RECOMMENDATION_PENDING": "En attente de la recommandation",
    "SUBMISSION_SENT": "Soumission envoyée",
    "WAITING_FOR_NOTIFICATION": "En attente de la notification du dossier complet "
  },
  "notification_ticket_roles_to_notify": {
    "INITIATOR": "Initiateur",
    "VALIDATOR_1": "Validateur 1",
    "VALIDATOR_2": "Validateur 2",
    "MANAGER_CRM": "Gestionnaire CRM",
    "APPROVER_CRM": "Approbateur CRM"
  }
}
